/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AccountBoxOutlined,
    BadgeOutlined,
    CategoryOutlined,
    MenuBookOutlined,
    ShoppingCartOutlined,
    LabelOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Productos from "./Secciones/Seccion_Productos";
import Seccion_Categorias from "./Secciones/Seccion_Categorias";
import Seccion_Mayoristas from "./Secciones/Seccion_Mayoristas";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";
import Seccion_Sub_Categorias from "./Secciones/Seccion_Sub_Categorias";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Pedidos',
        icono: ShoppingCartOutlined,
        camino: '/Pedidos',
        categoria: 'Pedidos',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Productos',
        icono: MenuBookOutlined,
        camino: '/Productos',
        categoria: 'Pagina',
        Componente: <Seccion_Productos/>
    },
    {
        nombre: 'Potenciales',
        icono: AccountBoxOutlined,
        camino: '/Potenciales',
        categoria: 'Pagina',
        Componente: <Seccion_Mayoristas/>
    },
    {
        nombre: 'Categorias',
        icono: CategoryOutlined,
        camino: '/Categorias',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Categorias/>
    },
    {
        nombre: 'Sub Categorias',
        icono: LabelOutlined,
        camino: '/SubCategorias',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Sub_Categorias/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}